import { jsx as t } from "react/jsx-runtime";
import { forwardRef as I } from "react";
import { LabeledField as a } from "./index.es512.js";
import { INPUT_FIELD_DEFAULT_TESTID as T } from "./index.es835.js";
import { BaseInputField as c } from "./index.es836.js";
const x = I(
  ({
    label: f,
    required: r,
    disabled: o,
    testId: e = T,
    feedback: p,
    isError: m = !1,
    asterix: l,
    infoTooltip: i,
    ...n
  }, F) => /* @__PURE__ */ t(
    a,
    {
      label: f,
      feedback: o ? [] : p,
      disabled: o,
      required: r,
      isError: m,
      asterix: l,
      testId: `${e}-label`,
      infoTooltip: i,
      children: /* @__PURE__ */ t(
        c,
        {
          ...n,
          required: r,
          testId: e,
          isError: m,
          disabled: o,
          ref: F
        }
      )
    }
  )
);
export {
  x as InputField
};
//# sourceMappingURL=index.es43.js.map
